<template>
  <div>
    <validation-component
      ref="bankFormRef"
      :validation-condition="bankCondition">
    </validation-component>
  </div>
</template>

<script>
import { REQUIRED, AllNumber, EN_NUMBER_SPACE } from '@/components/validation/tool/validator';
import ValidationComponent from '@/components/validation/validation.vue';
import { arr2obj, shallowClones } from '@/utils/tools/utils';
import { getCountryGroupListByName, queryBankInfoBySwiftAndCountry } from '@/views/transfer/api/contact';
import { ACCOUNT_TYPE_OPTIONS } from '@/views/transfer/api/options';

export default {
  components: { ValidationComponent },
  props: {
    contact: {
      type: Object,
      default: () => ({}),
    },
    txnFields: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      bankCondition: [
        {
          key: 'swiftCode',
          name: 'message.contact.swiftCodeInputTitle',
          type: 'select',
          defValue: '',
          rule: [],
          isShowStar: true,
          isHide: true,
          placeholder: 'message.contact.swiftCodeInputTips',
          remote: true,
          noDataText: 'message.contact.atLeast3SwiftCodeTips',
          filterMethod: async (value) => {
            const bankForm = this.$refs.bankFormRef;
            bankForm.setItemLoading('swiftCode', true);
            if (value && value.length > 2) {
              bankForm.setItemNoDataText('swiftCode', 'message.common.noDataText');
              this.swiftCodeList = await queryBankInfoBySwiftAndCountry({ country: this.contact.bankCountry, swiftCode: value });
            } else {
              bankForm.setItemNoDataText('swiftCode', 'message.contact.atLeast3SwiftCodeTips');
              this.swiftCodeList = [];
            }
            bankForm.setItemLoading('swiftCode', false);
            bankForm.setValidationSelectOptions('swiftCode', this.swiftCodeList);
          },
          validator: this.validateSwiftCode,
        },
        // {
        //   key: 'payee',
        //   name: 'message.contact.nickname',
        //   type: 'input',
        //   defValue: '',
        //   rule: [REQUIRED],
        //   isShowStar: true,
        // },
        {
          key: 'accountType',
          name: 'message.contact.acType',
          type: 'select',
          defValue: '',
          rule: [],
          isShowStar: true,
          options: [],
          isHide: true,
          validator: this.validateAccountType,
        },
        {
          key: 'bankHolderName',
          name: 'message.contact.accountName',
          type: 'input',
          defValue: '',
          rule: [],
          isShowStar: true,
          isHide: true,
          validator: this.validateBankHolderName,
          tipList: [{
            value: this.$t('message.contact.bankHolderNameTip'),
          }],
        },
        {
          key: 'cardNumber',
          name: 'message.contact.accountNumber',
          type: 'input',
          defValue: '',
          rule: [],
          isShowStar: true,
          isHide: true,
          validator: this.validateCardNumber,
          changeValue: (value) => {
            const v = value.replace(/\s+/g, '');
            this.$refs.bankFormRef.setItemValue('cardNumber', v.toUpperCase());
          },
        },
        // {
        //   key: 'payoutCurrency',
        //   name: 'message.contact.accountCurrency',
        //   type: 'select',
        //   defValue: [],
        //   rule: [REQUIRED],
        //   isShowStar: true,
        //   options: [],
        //   option: {
        //     label: 'value',
        //     value: 'value',
        //   },
        //   multiple: true,
        //   isDisabled: true,
        // },
        {
          key: 'sortCode',
          name: 'message.contact.bankCode',
          type: 'input',
          defValue: '',
          rule: [],
          isShowStar: true,
          isHide: true,
          validator: this.validateSortCode,
          tipList: [{
            value: this.$t('message.contact.bankCodeTips'),
          }],
        },
        {
          key: 'branchCode',
          name: 'message.contact.branchCode',
          type: 'input',
          defValue: '',
          rule: [],
          isShowStar: true,
          isHide: true,
          validator: this.validateBranchCode,
        },
      ],
      swiftCodeList: [],
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    async initData() {
      const bankForm = this.$refs.bankFormRef;
      const bankCountry = this.contact.bankCountry;
      const entityType = this.contact.entityType;

      // 获取欧洲国家
      // let euCountryMap = {};
      // try {
      //   const res = await getCountryGroupListByName({ countryGroupName: 'payment-EU' });
      //   const euCountryList = (res.countryGroupInfos || []).map((item) => ({
      //     description: item.description,
      //     value: item.value,
      //   }));
      //   euCountryMap = arr2obj(euCountryList, { key: 'value' });
      // } catch (err) {
      //   //
      // }

      let accountTypeOptions = ACCOUNT_TYPE_OPTIONS;
      if (bankCountry !== 'JP') {
        accountTypeOptions = ACCOUNT_TYPE_OPTIONS.filter(item => item.value !== 'ordinary');
      }
      bankForm.setValidationSelectOptions('accountType', shallowClones(accountTypeOptions));

      let showCardNumber = false;
      for (let i = 0; i < this.txnFields.length; i++) {
        const key = this.txnFields[i].key;
        const field = this.txnFields[i].field;
        if (['swiftCode', 'accountType', 'bankHolderName', 'cardNumber', 'sortCode', 'branchCode', 'iban'].includes(key)) { // 银行账户
          if (key === 'cardNumber') {
            showCardNumber = field !== 'N';
            bankForm.setItemName('cardNumber', this.$t('message.contact.accountNumber'));
            bankForm.setItemHide('cardNumber', field === 'N');
            bankForm.setItemRequire('cardNumber', field === 'Y');
          } else if (key === 'iban') { // 字段映射
            if (!showCardNumber) {
              bankForm.setItemName('cardNumber', 'IBAN');
              bankForm.setItemHide('cardNumber', field === 'N');
              bankForm.setItemRequire('cardNumber', field === 'Y');
            }
          } else {
            bankForm.setItemHide(key, field === 'N');
            bankForm.setItemRequire(key, field === 'Y');
          }
        }
      }

      // if (bankCountry === 'GB' || euCountryMap[bankCountry]) {
      //   bankForm.setItemName('cardNumber', 'IBAN');
      // } else {
      //   bankForm.setItemName('cardNumber', this.$t('message.contact.accountNumber'));
      // }
      // if (['ID', 'PH', 'US', 'CA', 'BR', 'KR', 'GB', 'JP'].includes(bankCountry)) { // 当“付款地区”为Indonesia、Philippines、United States、Canada、brazil、South Korea、United Kingdom时必填
      //   bankForm.setItemHide('sortCode', false);
      // }
      // if (['BR', 'CA', 'ID', 'JP', 'VN'].includes(bankCountry)) { // 当“付款地区”为Brazil、Canada、Indonesia、Japan时必填
      //   bankForm.setItemHide('branchCode', false);
      // }

      // if (['ID'].includes(bankCountry) && `${entityType}` === '0') { // 当“付款地区”为Indonesia时必填
      //   bankForm.setItemHide('bankHolderName', false);
      // }

      if (this.contact.swiftCode) {
        this.swiftCodeList = await queryBankInfoBySwiftAndCountry({ country: this.contact.bankCountry, swiftCode: this.contact.swiftCode });
        bankForm.setValidationSelectOptions('swiftCode', this.swiftCodeList);
      }

      bankForm.assignmentFormValue({
        ...this.contact,
        // payoutCurrency: this.contact.payoutCurrency.split(','),
      });
    },
    validate() { // 静默校验避免出现错误提示
      const data = this.$refs.bankFormRef.getFormJson();
      for (let i = 0; i < this.bankCondition.length; i++) {
        const item = this.bankCondition[i];
        if (!item.isHide) {
          if (item.validator && !item.validator(null, data[item.key])) {
            return false;
          } else if (item.rule && item.rule.length && !data[item.key]) {
            return false;
          }
        }
      }
      return true;
    },
    async getValidateData() {
      const bankFormValid = await this.$refs.bankFormRef.validateAsync();
      if (!bankFormValid) {
        return null;
      }
      const data = this.$refs.bankFormRef.getFormJson();
      for (let i = 0; i < this.swiftCodeList.length; i++) {
        const item = this.swiftCodeList[i];
        if (data.swiftCode === item.value) {
          data.bankName = item.bankName;
          break;
        }
      }
      // data.payoutCurrency = data.payoutCurrency.join(',');
      return data;
    },
    isFieldRequired(key) {
      let required = false;
      for (let i = 0; i < this.txnFields.length; i++) {
        if (this.txnFields[i].key === key) {
          required = this.txnFields[i].field === 'Y';
          break;
        }
      }
      return required;
    },
    validateSwiftCode(rule, value, callback = () => {}) {
      if (this.isFieldRequired('swiftCode') && (!value || REQUIRED.regExp.test(value))) {
        callback(new Error(this.$t('message.validator.required')));
        return false;
      }
      callback();
      return true;
    },
    validateAccountType(rule, value, callback = () => {}) {
      if (this.isFieldRequired('accountType') && (!value || REQUIRED.regExp.test(value))) {
        callback(new Error(this.$t('message.validator.required')));
        return false;
      }
      callback();
      return true;
    },
    validateBankHolderName(rule, value, callback = () => {}) {
      if (this.isFieldRequired('bankHolderName') && (!value || REQUIRED.regExp.test(value))) {
        callback(new Error(this.$t('message.validator.required')));
        return false;
      }
      if (value && !EN_NUMBER_SPACE.regExp.test(value)) {
        callback(new Error(this.$t('message.validator.enNumberSpace')));
        return false;
      }
      callback();
      return true;
    },
    validateCardNumber(rule, value, callback = () => {}) {
      if (this.isFieldRequired('cardNumber') && (!value || REQUIRED.regExp.test(value))) {
        callback(new Error(this.$t('message.validator.required')));
        return false;
      }
      callback();
      return true;
    },
    validateSortCode(rule, value, callback = () => {}) {
      const bankCountry = this.contact.bankCountry;
      if (this.isFieldRequired('sortCode') && (!value || REQUIRED.regExp.test(value))) {
        callback(new Error(this.$t('message.validator.required')));
        return false;
      }
      if (!value) {
        callback();
        return true;
      }
      // Indonesia：Numeric (3)
      // Philippines：Numeric (9)
      // United States：Numeric (9)，对应ABA Routing Number
      // Canada：String (3)
      // brazil：Numeric (3)
      // South Korea：Numeric (3)
      // United Kingdom：Numeric (6)，对应Sort Code
      if (bankCountry === 'ID') {
        if (!AllNumber.regExp.test(value)) {
          callback(new Error(this.$t('message.validator.inputNumber')));
          return false;
        }
        if (value.length !== 3) {
          callback(new Error(this.$t('message.validator.inputLength', { length: '3' })));
          return false;
        }
      }
      if (bankCountry === 'PH') {
        if (!AllNumber.regExp.test(value)) {
          callback(new Error(this.$t('message.validator.inputNumber')));
          return false;
        }
        if (value.length !== 9) {
          callback(new Error(this.$t('message.validator.inputLength', { length: '9' })));
          return false;
        }
      }
      if (bankCountry === 'US') {
        if (!AllNumber.regExp.test(value)) {
          callback(new Error(this.$t('message.validator.inputNumber')));
          return false;
        }
        if (value.length !== 9) {
          callback(new Error(this.$t('message.validator.inputLength', { length: '9' })));
          return false;
        }
      }
      if (bankCountry === 'CA' && value.length !== 3) {
        callback(new Error(this.$t('message.validator.inputLength', { length: '3' })));
        return false;
      }
      if (bankCountry === 'BR') {
        if (!AllNumber.regExp.test(value)) {
          callback(new Error(this.$t('message.validator.inputNumber')));
          return false;
        }
        if (value.length !== 3) {
          callback(new Error(this.$t('message.validator.inputLength', { length: '3' })));
          return false;
        }
      }
      if (bankCountry === 'KR') {
        if (!AllNumber.regExp.test(value)) {
          callback(new Error(this.$t('message.validator.inputNumber')));
          return false;
        }
        if (value.length !== 3) {
          callback(new Error(this.$t('message.validator.inputLength', { length: '3' })));
          return false;
        }
      }
      if (bankCountry === 'GB') {
        if (!AllNumber.regExp.test(value)) {
          callback(new Error(this.$t('message.validator.inputNumber')));
          return false;
        }
        if (value.length !== 6) {
          callback(new Error(this.$t('message.validator.inputLength', { length: '6' })));
          return false;
        }
      }
      if (bankCountry === 'JP') {
        if (!AllNumber.regExp.test(value)) {
          callback(new Error(this.$t('message.validator.inputNumber')));
          return false;
        }
        if (value.length !== 4) {
          callback(new Error(this.$t('message.validator.inputLength', { length: '4' })));
          return false;
        }
      }
      callback();
      return true;
    },
    validateBranchCode(rule, value, callback = () => {}) {
      const bankCountry = this.contact.bankCountry;
      if (this.isFieldRequired('branchCode') && (!value || REQUIRED.regExp.test(value))) {
        callback(new Error(this.$t('message.validator.required')));
        return false;
      }
      if (!value) {
        callback();
        return true;
      }
      // Brazil：String (1-4)
      // Canada：String (5)
      // Indonesia：Numeric (4)
      // Japan：Numeric (3)
      if (bankCountry === 'BR' && value.length > 4) {
        callback(new Error(this.$t('message.validator.inputLength', { length: '[1-4]' })));
        return false;
      }
      if (bankCountry === 'CA' && value.length !== 5) {
        callback(new Error(this.$t('message.validator.inputLength', { length: '5' })));
        return false;
      }
      if (bankCountry === 'ID') {
        if (!AllNumber.regExp.test(value)) {
          callback(new Error(this.$t('message.validator.inputNumber')));
          return false;
        }
        if (value.length !== 4) {
          callback(new Error(this.$t('message.validator.inputLength', { length: '4' })));
          return false;
        }
      }
      if (bankCountry === 'JP') {
        if (!AllNumber.regExp.test(value)) {
          callback(new Error(this.$t('message.validator.inputNumber')));
          return false;
        }
        if (value.length !== 3) {
          callback(new Error(this.$t('message.validator.inputLength', { length: '3' })));
          return false;
        }
      }
      if (bankCountry === 'VN') {
        if (!AllNumber.regExp.test(value)) {
          callback(new Error(this.$t('message.validator.inputNumber')));
          return false;
        }
        if (value.length > 5) {
          callback(new Error(this.$t('message.validator.inputLength', { length: '[1, 5]' })));
          return false;
        }
      }
      callback();
      return true;
    },
  },
};
</script>

<style>

</style>
